export const SERVER = "https://pay.karafsapp.com/admin";
export const SERVER_DOMAIN = "https://v2.karafsapp.com";
export const ROLES = {
  SUPER_ADMIN: "SUPER_ADMIN",
  FINANCIAL: "FINANCIAL_ADMIN",
  INVOICE: "INVOICE_ADMIN",
};
